module.exports = __webpack_public_path__ + "static/media/Shame on Me (ft Ashley DuBose).42d2ec2d.jpg";